<template>
  <div class="gray-80">
    <span class="d-block text-truncate">
      <span class="svg-icon gray-30 mr-10" aria-hidden="true">
        <svg
          class="svg-icon__svg"
          :width="iconSize"
          :height="iconSize"
          focusable="false"
        >
          <use xlink:href="/img/static/svg-sprites.svg#icon-calendar"></use>
        </svg> </span
      >{{ dateFrom }} - {{ dateTo }} ({{ duration }} dni)
    </span>
    <span class="d-block" v-if="type == 'F'">
      <span class="svg-icon gray-30 mr-10" aria-hidden="true">
        <svg
          class="svg-icon__svg"
          :width="iconSize"
          :height="iconSize"
          focusable="false"
        >
          <use xlink:href="/img/static/svg-sprites.svg#icon-plane-45"></use>
        </svg> </span
      >{{ depDesc }}
    </span>
    <span class="d-block" v-if="type == 'BU'">
      <span class="svg-icon gray-30 mr-10" aria-hidden="true">
        <svg
          class="svg-icon__svg"
          :width="iconSize"
          :height="iconSize"
          focusable="false"
        >
          <use xlink:href="/img/static/svg-sprites.svg#icon-bus"></use>
        </svg> </span
      >{{ depDesc }}
    </span>
    <span class="d-block" v-if="type == 'H'">
      <span class="svg-icon gray-30 mr-10" aria-hidden="true">
        <svg
          class="svg-icon__svg"
          :width="iconSize"
          :height="iconSize"
          focusable="false"
        >
          <use xlink:href="/img/static/svg-sprites.svg#icon-car"></use>
        </svg> </span
      >Dojazd własny
    </span>
    <span class="d-block">
      <span class="svg-icon gray-30 mr-10" aria-hidden="true">
        <svg
          class="svg-icon__svg"
          :width="iconSize"
          :height="iconSize"
          focusable="false"
        >
          <use xlink:href="/img/static/svg-sprites.svg#icon-food"></use>
        </svg> </span
      >{{ service }}
    </span>
    <span class="d-block">
      <span class="svg-icon gray-30 mr-10" aria-hidden="true">
        <svg
          class="svg-icon__svg"
          :width="iconSize"
          :height="iconSize"
          focusable="false"
        >
          <use xlink:href="/img/static/svg-sprites.svg#icon-compass"></use>
        </svg> </span
      >{{ touropName }}
    </span>
  </div>
</template>

<script>
export default {
  name: "trip-details",
  props: {
    dateFrom: String,
    dateTo: String,
    depDesc: [Array, String],
    duration: String,
    service: String,
    touropName: String,
    type: String,
    iconSize: String,
  },
};
</script>
